import awIconService from 'js/awIconService';
import AwPic from 'viewmodel/AwPicViewModel';

/**
 * render function for des compact image cell
 * @param {*} param0 context for render function interpolation
 * @returns {JSX.Element} react component
 */
export const desCompactImageCellRenderFunction = ( props ) => {
    const {
        viewModel,
        ctxMin,
        actions,
        i18n,
        fields,
        grids,
        formProp,
        messages,
        ...prop
    } = props;
    let { item, vmo } = prop;
    if( !item ) {
        item = vmo;
    }
    const thumbnailUrl = awIconService.getThumbnailFileUrl( item );
    return (
        <div className='des-compact-imagecell-container' title={vmo.cellHeader1}>
            {
                thumbnailUrl ? <div className='sw-imagecell-thumbnailContainer1'>
                    <AwPic source={thumbnailUrl} className='sw-imagecell-thumbnail-commented des-aw-pic'></AwPic>
                    </div> : ''
            }
            {/* <AwDefaultCell {...prop}></AwDefaultCell> */}
        </div>
    );
};
